var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, ConfigProvider, Tooltip, Typography, theme, } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
/**
 * Shared bulk-selection bar rendered above tables (visits, deliveries,
 * meeting services) so every surface gets the same blue bar: a clear (X)
 * button, "{count} selected" text, then action buttons as children.
 *
 * Callers own their i18n: pass the already-translated "selected" word and a
 * clear-selection label (used for the X button's tooltip and a11y title).
 */
export var BulkActionsBar = function (_a) {
    var selectedCount = _a.selectedCount, selectedLabel = _a.selectedLabel, clearSelectionLabel = _a.clearSelectionLabel, onClearSelection = _a.onClearSelection, children = _a.children;
    var token = theme.useToken().token;
    return (_jsxs(BarContainer, { children: [_jsx(ConfigProvider, { theme: {
                    components: {
                        Button: {
                            textTextColor: token.colorWhite,
                            textTextHoverColor: token.colorWhite,
                            textTextActiveColor: token.colorWhite,
                            textHoverBg: 'rgba(255, 255, 255, 0.15)',
                        },
                    },
                }, children: _jsx(Tooltip, { title: clearSelectionLabel, children: _jsx(ClearButton, { icon: _jsx(FontAwesomeIcon, { icon: faClose, color: token.colorWhite }), onClick: onClearSelection, type: "text", size: "small", "aria-label": clearSelectionLabel }) }) }), _jsxs(BarText, { children: [selectedCount, " ", selectedLabel] }), children] }));
};
/**
 * Icon-only action button for the bar. `label` drives the tooltip and the
 * button's title/aria-label so screen readers announce what the icon does.
 */
export var BulkActionIconButton = function (_a) {
    var label = _a.label, icon = _a.icon, onClick = _a.onClick, danger = _a.danger, disabled = _a.disabled, loading = _a.loading;
    return (_jsx(ConfigProvider, { theme: {
            components: {
                Button: {
                    defaultShadow: 'none',
                },
            },
        }, children: _jsx(Tooltip, { title: label, children: _jsx(Button, { type: "default", size: "small", danger: danger, disabled: disabled, loading: loading, onClick: onClick, icon: _jsx(FontAwesomeIcon, { icon: icon }), "aria-label": label }) }) }));
};
var BarContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  background-color: var(--ant-color-info, #2774c1);\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  padding: 8px;\n"], ["\n  border-radius: 4px;\n  background-color: var(--ant-color-info, #2774c1);\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  padding: 8px;\n"])));
var ClearButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-shadow: none;\n\n  path {\n    fill: var(--ant-color-white, #fff);\n  }\n"], ["\n  box-shadow: none;\n\n  path {\n    fill: var(--ant-color-white, #fff);\n  }\n"])));
var BarText = styled(Typography.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: var(--ant-color-white, #fff);\n  margin-right: 8px;\n"], ["\n  color: var(--ant-color-white, #fff);\n  margin-right: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
